import gql from 'graphql-tag'

export const signalUser = gql`
  mutation signalUser($signal_user: SignalForm!) {
    signalUser(signal_user: $signal_user)
  }
`
